import { combineReducers } from 'redux'

import invoices from './invoices'
import inventories from './inventory'
import clients from './clients'
import vendors from './vendors'
import metals from './metals'
import auth from './auth'
import profiles from './profiles'

export default combineReducers({ invoices, inventories, clients,vendors, metals, auth, profiles })